
  import { PropType, defineComponent, ref } from 'vue'

  import CalendarWorkout from '@/components/Dashboard/UserCalendar/CalendarWorkout.vue'
  import DonutChart from '@/components/Dashboard/UserCalendar/DonutChart.vue'
  import { ISport } from '@/types/sports'
  import { IWorkout } from '@/types/workouts'
  import { getSportLabel } from '@/utils/sports'

  export default defineComponent({
    name: 'CalendarWorkoutsChart',
    components: {
      CalendarWorkout,
      DonutChart,
    },
    props: {
      colors: {
        type: Object as PropType<Record<number, string>>,
        required: true,
      },
      datasets: {
        type: Object as PropType<Record<number, Record<string, number>>>,
        required: true,
      },
      sports: {
        type: Object as PropType<ISport[]>,
        required: true,
      },
      workouts: {
        type: Object as PropType<IWorkout[]>,
        required: true,
      },
    },
    setup() {
      const isHidden = ref(true)
      function togglePane(event: Event & { target: HTMLElement }) {
        event.stopPropagation()
        isHidden.value = !isHidden.value
      }
      return { isHidden, getSportLabel, togglePane }
    },
  })
